import React from 'react'
import './footer.css'

const Footer = () => {
    return (
        <footer className='footer-container'>
            <div className='footer-wrap'>
                <div className='footer-info'>
                    <div className='footer-info-one'>Tweencraft Copyright Info</div>
                    <div className='footer-duns-seal'>
                        <iframe
                            title='DUNS Registered Seal'
                            src='https://dunsregistered.dnb.com/SealAuthentication.aspx?Cid=1'
                            width='114'
                            height='97'
                            frameBorder='0'
                            scrolling='no'
                            style={{ background: 'transparent' }}
                        />
                    </div>
                    <div className='footer-info-two'><div>Write to us:&nbsp;</div><a className='footer-mail-link' href='mailto:info@kalpkriti.com'>info@kalpkriti.com</a></div>
                </div>
            </div>
        </footer>
    )
}

export default Footer
